module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore40-23158ffaaee0ffb000d4513ac6ae4e0a.jpg";